import React from 'react';
interface WidgetCardProps {
  title: string;
  children: ReactNode;
  actionArea?: ReactNode;
  icon?: ReactNode;
  className?: string;
  contentClassName?: string;
  subtitle?: string;
}
export function WidgetCard({
  title,
  children,
  actionArea,
  icon,
  className = '',
  contentClassName = '',
  subtitle
}: WidgetCardProps) {
  return <div className={`bg-white rounded-lg border border-gray-200/70 overflow-hidden ${className}`} data-id="element-262">
      <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-100" data-id="element-263">
        <div className="flex items-center" data-id="element-264">
          {icon && <span className="mr-2" data-id="element-265">{icon}</span>}
          <div data-id="element-266">
            <h2 className="text-base font-semibold text-[#164149]" data-id="element-267">
              {title === 'Investimento Royalties' ? 'Royalty Investment' : title}
            </h2>
            {subtitle && <p className="text-xs text-[#7F9EA4] mt-1" data-id="element-268">{subtitle}</p>}
          </div>
        </div>
        {actionArea && <div data-id="element-269">{actionArea}</div>}
      </div>
      <div className={`px-4 sm:px-6 py-5 ${contentClassName}`} data-id="element-270">
        {title === 'Investimento Royalties' ? <div data-id="element-271">
            {/* Carousel header with scroll indicators */}
            <div className="flex items-center justify-between mb-3" data-id="element-272">
              <div className="text-sm font-medium text-gray-700" data-id="element-273">
                Works available for investment
              </div>
              <div className="text-xs text-gray-500" data-id="element-274">
                Scroll to see more works →
              </div>
            </div>
            {/* Enhanced carousel container with clear horizontal scroll */}
            <div className="relative" data-id="element-275">
              {/* Left shadow indicator */}
              <div className="absolute top-0 left-0 bottom-0 w-12 bg-gradient-to-r from-white to-transparent pointer-events-none z-10 hidden sm:block" data-id="element-276"></div>
              {/* Improved overflow container */}
              <div className="overflow-x-auto scrollbar-hide pb-4 -mx-1 px-1" data-id="element-277">
                <div className="flex space-x-4 w-max whitespace-nowrap" data-id="element-278">
                  {/* Royalty investment items - now 4 books in a row */}
                  {[1, 2, 3, 4].map(item => <div key={item} className="w-[220px] flex-shrink-0 border border-gray-100 rounded-lg p-3 hover:shadow-sm transition-shadow" data-id="element-279">
                      <div className="flex items-center mb-3" data-id="element-280">
                        <div className="w-[60px] h-[90px] flex-shrink-0 shadow-sm rounded-md overflow-hidden" data-id="element-281">
                          <img src={`https://uploadthingy.s3.us-west-1.amazonaws.com/${['67FfJDXox9973Yr212r9mt/IMG_0033.webp', 'mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp', 'ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp', 'mH3hvE4SdWb6hacSUtkerR/IMG_0029.webp'][item - 1]}`} alt={`Book cover ${item}`} className="w-full h-full object-cover" data-id="element-282" />
                        </div>
                        <div className="ml-3 flex-1 min-w-0" data-id="element-283">
                          <h3 className="font-medium text-[#164149] text-sm truncate" data-id="element-284">
                            {['The Garden Among Clouds', 'Love & Lies', 'The Mist Forest', 'Think Like a Boss'][item - 1]}
                          </h3>
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-2 mb-3" data-id="element-285">
                        <div data-id="element-286">
                          <div className="text-xs text-gray-500" data-id="element-287">
                            Transferred
                          </div>
                          <div className="text-sm font-medium text-gray-900" data-id="element-288">
                            {[30, 25, 40, 35][item - 1]}%
                          </div>
                        </div>
                        <div data-id="element-289">
                          <div className="text-xs text-gray-500" data-id="element-290">Price</div>
                          <div className="text-sm font-medium text-gray-900" data-id="element-291">
                            {['€15,000', '€12,000', '€18,000', '€14,000'][item - 1]}
                          </div>
                        </div>
                        <div data-id="element-292">
                          <div className="text-xs text-gray-500" data-id="element-293">Min. inv.</div>
                          <div className="text-sm font-medium text-gray-900" data-id="element-294">
                            0.5%
                          </div>
                        </div>
                      </div>
                      <button className="w-full px-3 py-1.5 bg-[#376770] text-white text-xs rounded hover:bg-[#2d5459] transition-colors" data-id="element-295">
                        Contact Elze Team
                      </button>
                    </div>)}
                </div>
              </div>
              {/* Right shadow indicator */}
              <div className="absolute top-0 right-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent pointer-events-none" data-id="element-296"></div>
            </div>
          </div> : children}
      </div>
    </div>;
}
// Custom filled Facebook icon to replace the outline version from lucide-react
export function FacebookFilled(props) {
  const {
    size = 24,
    color = 'currentColor',
    ...rest
  } = props;
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={color} {...rest} data-id="element-297">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-298" />
    </svg>;
}